import { GallerySelectItem } from './types';

// We sort subfolders to be immediately after their parent with the only UX purpose of
// later adding some padding to these items and give the idea of nesting
export function sortGalleryItems(items: GallerySelectItem[]) {
  const parentFolders = items.filter(item => !item.gallery.parentId);
  const subFolders = items.filter(item => item.gallery.parentId);

  return parentFolders.reduce(
    (accumulator, parentFolder) => [
      ...accumulator,
      parentFolder,
      ...subFolders.filter(
        ({ gallery: { parentId } }) =>
          parentId === parentFolder.gallery.folderId
      ),
    ],
    []
  );
}

export function isPremiumGalleryItem(item: GallerySelectItem | undefined) {
  return !!item?.gallery?.premiumFolderData;
}

export function getSelectedFolderIds(items: GallerySelectItem[]) {
  return items.filter(item => item.selected).map(item => parseInt(item.value));
}

export function updateSelectedValue(
  items: GallerySelectItem[],
  isSelected: boolean,
  value: string
) {
  // T60653: Can only select multiple folders if they're not premium
  const selectedIsPremium = isPremiumGalleryItem(
    items.find(item => item.value === value)
  );
  return items.map(item => {
    const selected =
      item.value === value
        ? isSelected
        : selectedIsPremium || isPremiumGalleryItem(item)
        ? false
        : item.selected;
    return {
      ...item,
      selected,
    };
  });
}
